import * as React from "react"
import {
  MainContainer,
  Heading,
  Cta,
  InnerContainer,
  Subheading,
  Flex,
} from "./abstractStyles"
import "./buttonHover.css"
import Fade from "react-reveal/Fade"
import { ImAlarm } from "react-icons/im"
import { FcCalendar } from "react-icons/fc"
import { HiOutlineCalendar } from "react-icons/hi"
import { MdAddCircle } from "react-icons/md"
import { CgAdd } from "react-icons/cg"
import AddToCalendar from "react-add-to-calendar"
import { Link } from "gatsby"

const AbstractSubmission = () => {
  let links = [
    { text: "Submit Abstract", link: "submit-abstract" },
    { text: "Conference Brochure", link: "" },
    { text: "Venue Details", link: "" },
    { text: "Program", link: "" },
  ]
  let event = {
    title: "Sample Event",
    description: "This is the sample event provided as an example only",
    location: "Portland, OR",
    startTime: "2016-09-16T20:15:00-04:00",
    endTime: "2016-09-16T21:45:00-04:00",
  }
  return (
    <>
      <MainContainer>
        <Heading>
          <span
            style={{
              marginRight: "10px",
            }}
          >
            <ImAlarm color="#30cfd0" />
          </span>
          <span>Reminders</span>
        </Heading>
        <Subheading>
          {" "}
          <HiOutlineCalendar
            style={{ marginRight: "8px" }}
            color="#fff"
            size="2rem"
          />
          <span>
            Early Bird Registration Ends on{" "}
            <span style={{ fontWeight: "bold" }}>26-08-2021</span>
          </span>
          {/* <CgAdd
            style={{ marginLeft: "8px", cursor: "pointer" }}
            color="#fff"
            size="1.5rem"
          /> */}
        </Subheading>
        <Subheading style={{ marginTop: "40px" }}>
          {" "}
          <HiOutlineCalendar
            style={{ marginRight: "8px" }}
            color="#fff"
            size="2rem"
          />
          <span>
            Abstract &nbsp;Submission &nbsp;Ends on{" "}
            <span style={{ fontWeight: "bold" }}>26-09-2021</span>
          </span>
          {/* <CgAdd
            style={{ marginLeft: "8px", cursor: "pointer" }}
            color="#fff"
            size="1.5rem"
          /> */}
        </Subheading>

        <Heading style={{ marginTop: "80px" }}>Quick Explore</Heading>
        <Fade up>
          <InnerContainer style={{ marginTop: "52px" }}>
            <Flex>
              {links.map(node => (
                <Link style={{ textDecoration: "none" }} to={node.link}>
                  <Cta className="hvr-shrink">{node.text}</Cta>
                </Link>
              ))}
            </Flex>
          </InnerContainer>
        </Fade>
      </MainContainer>
    </>
  )
}

export default AbstractSubmission
